export default {
  "viewDocument": "Ver",
  "unableToLoadBudgets": "No se pueden cargar los presupuestos.",
  "budgetUpdated": "Presupuesto actualizado",
  "theBudgetDetailsHaveBeenSaved": "Se han guardado los datos del presupuesto.",
  "unableToUpdateBudget": "No se puede actualizar el presupuesto",
  "pleaseTryAgainInAMoment": "Vuelva a intentarlo en un momento.",
  "budgetDeleted": "Presupuesto eliminado",
  "theBudgetHasBeenRemoved": "Se ha eliminado el presupuesto.",
  "budgetCannotBeDeleted": "No se puede eliminar este presupuesto",
  "unableToDeleteBudget": "No se puede eliminar el presupuesto",
  "onlyDraftBudgetsWithoutLockedVersionsCanBeDeleted": "Solo se pueden eliminar presupuestos en borrador que no tengan versiones bloqueadas.",
  "unableToCreateBudget": "No se puede crear el presupuesto.",
  "newBudget": "Nuevo presupuesto",
  "createANewBudget": "Crear un presupuesto",
  "name": "Nombre",
  "fy2025OperatingBudget": "Presupuesto operativo del ejercicio 2025",
  "fiscalYearStart": "Inicio del ejercicio fiscal",
  "fiscalYearEnd": "Fin del ejercicio fiscal",
  "copyFromBudgetOptional": "Copiar de un presupuesto (opcional)",
  "selectBudget": "Seleccionar presupuesto",
  "noCopy": "Sin copia",
  "copyFromVersionOptional": "Copiar de una versión (opcional)",
  "selectVersion": "Seleccionar versión",
  "currentVersion": "Versión actual",
  "cancel": "Cancelar",
  "createBudget": "Crear presupuesto",
  "budgetingError": "Error de presupuestos",
  "loadingBudgets": "Cargando presupuestos…",
  "editBudget": "Editar presupuesto",
  "saveChanges": "Guardar cambios",
  "deleteBudget": "Eliminar presupuesto",
  "delete": "Eliminar",
  "noBudgetsYetClickNewBudgetToCreateYourFirstBudget": "Todavía no hay presupuestos. Pulse «Nuevo presupuesto» para crear el primero.",
  "fiscalYear": "Ejercicio fiscal",
  "status": "Estado",
  "updated": "Actualizado",
  "open": "Abrir",
  "openBudgetActions": "Abrir acciones del presupuesto",
  "edit": "Editar",
  "jan": "ene",
  "feb": "feb",
  "mar": "mar",
  "apr": "abr",
  "may": "may",
  "jun": "jun",
  "jul": "jul",
  "aug": "ago",
  "sep": "sept",
  "oct": "oct",
  "nov": "nov",
  "dec": "dic",
  "q1": "T1",
  "q2": "T2",
  "q3": "T3",
  "q4": "T4",
  "draft": "Borrador",
  "submitted": "Enviado",
  "boardApproved": "Aprobado por la junta",
  "locked": "Bloqueado",
  "rejected": "Rechazado",
  "originalBudget": "Presupuesto original",
  "reforecast": "Previsión revisada",
  "boardMandated": "Por mandato de la junta",
  "other": "Otro",
  "operating": "Operativo",
  "capex": "Inversión de capital",
  "fyDatesNotSet": "Fechas del ejercicio sin definir",
  "allDepartments": "Todos los departamentos",
  "selectGlAccount": "Seleccionar cuenta contable",
  "searchGlAccounts": "Buscar cuentas contables…",
  "noGlAccountsFound": "No se encontraron cuentas contables.",
  "selectDepartment": "Seleccionar departamento",
  "searchDepartments": "Buscar departamentos…",
  "noDepartmentsFound": "No se encontraron departamentos.",
  "unableToLoadBudgetDetails": "No se pueden cargar los datos del presupuesto.",
  "unableToLoadReferenceData": "No se pueden cargar los datos de referencia.",
  "unableToLoadBudgetLines": "No se pueden cargar las partidas del presupuesto.",
  "couldntLoadYourAutosavePreference": "No se pudo cargar su preferencia de guardado automático",
  "autosaveIsOffByDefaultUntilWeCanLoadYourSetting": "El guardado automático permanece desactivado hasta que se pueda cargar su configuración.",
  "allCategories": "Todas las categorías",
  "lineAlreadyExists": "La partida ya existe",
  "aBudgetLineWithTheseDetailsAlreadyExists": "Ya existe una partida presupuestaria con estos datos.",
  "unableToPrepareAttachments": "No se pueden preparar los archivos adjuntos",
  "pleaseTryAgain": "Vuelva a intentarlo.",
  "lineDetailsChanged": "Datos de la partida modificados",
  "attachmentsWereClearedPleaseReuploadAnyDocuments": "Se han borrado los archivos adjuntos. Vuelva a cargar los documentos.",
  "unableToDiscardDraftLine": "No se puede descartar la partida en borrador",
  "autosaved": "Guardado automáticamente",
  "changesSavedAutomatically": "Cambios guardados automáticamente.",
  "budgetSaved": "Presupuesto guardado",
  "changesHaveBeenSaved": "Se han guardado los cambios.",
  "unableToSaveBudgetLines": "No se pueden guardar las partidas del presupuesto.",
  "autosaveFailed": "Error de guardado automático",
  "autosaveFailedPleaseClickSaveChanges": "No se pudieron guardar los cambios automáticamente. Pulse «Guardar cambios».",
  "readonlyVersion": "Versión de solo lectura",
  "readonlyVersionCantBeAutosaved": "Las versiones de solo lectura no permiten el guardado automático.",
  "unableToUpdateAutosave": "No se puede actualizar el guardado automático",
  "unableToDeleteLine": "No se puede eliminar la partida.",
  "newVersionCreated": "Nueva versión creada",
  "aNewDraftVersionIsReadyForEditing": "La nueva versión en borrador está lista para editar.",
  "unableToCreateNewVersion": "No se puede crear una nueva versión.",
  "versionDetailsUpdated": "Datos de la versión actualizados",
  "versionMetadataSavedSuccessfully": "Se han guardado los datos de la versión.",
  "unableToUpdateVersion": "No se puede actualizar la versión",
  "pleaseTryAgainOrRefreshThePage": "Vuelva a intentarlo o actualice la página.",
  "unableToUpdateCurrentVersion": "No se puede actualizar la versión actual.",
  "submittedToTheGmForReleaseVotingWillOpenOnceApproved": "Enviado a la dirección general para su publicación. La votación se abrirá tras su aprobación.",
  "votingAlreadyOpen": "La votación ya está abierta",
  "votingIsAlreadyOpenForThisBudgetRefreshingTheMotionStatus": "La votación de este presupuesto ya está abierta. Actualizando el estado de la moción.",
  "alreadySubmitted": "Ya enviado",
  "thisBudgetIsAlreadyQueuedForGmRelease": "Este presupuesto ya está pendiente de publicación por la dirección general.",
  "votingAlreadyClosed": "La votación ya está cerrada",
  "thisBudgetMotionHasAlreadyBeenClosed": "La moción de este presupuesto ya se ha cerrado.",
  "submissionFailed": "Error de envío",
  "unableToSubmitThisBudgetForBoardApproval": "No se puede enviar este presupuesto para su aprobación por la junta.",
  "withdrawSubmissionThisWillRevertToDraftAndRemoveItFromTheBoardQueue": "¿Retirar el envío? El presupuesto volverá a borrador y se retirará de la cola de la junta.",
  "submissionWithdrawnBudgetIsBackInDraft": "Envío retirado. El presupuesto vuelve a estar en borrador.",
  "thisSubmissionCanOnlyBeWithdrawnBeforeVotingOpens": "Solo se puede retirar el envío antes de que se abra la votación.",
  "votesAlreadyExistForThisMotion": "Ya hay votos registrados para esta moción.",
  "thisBudgetVersionIsNotCurrentlySubmitted": "Esta versión del presupuesto no está enviada actualmente.",
  "noPendingMotionWasFoundForThisSubmission": "No se encontró ninguna moción pendiente para este envío.",
  "unableToWithdrawSubmission": "No se puede retirar el envío",
  "unableToDeleteBudgetEnsureItIsInDraftAndNoVersionsAreLocked": "No se puede eliminar el presupuesto. Compruebe que esté en borrador y que no haya versiones bloqueadas.",
  "statusUpdated": "Estado actualizado",
  "unableToUpdateStatus": "No se puede actualizar el estado",
  "thisReopensAnApprovedBudgetAndAllowsEditsContinue": "Se reabrirá un presupuesto aprobado y se permitirán cambios. ¿Desea continuar?",
  "lockedBudgetsCannotBeEditedAgainContinue": "Los presupuestos bloqueados no se pueden volver a editar. ¿Desea continuar?",
  "loadingBudgetDetails": "Cargando datos del presupuesto…",
  "backToBudgeting": "Volver a presupuestos",
  "budgetNotFound": "Presupuesto no encontrado",
  "theSelectedBudgetCouldNotBeFoundForThisClub": "No se encontró el presupuesto seleccionado para este club.",
  "backToBudgets": "Volver a presupuestos",
  "newVersion": "Nueva versión",
  "createANewVersion": "Crear una nueva versión",
  "createFromCurrentVersion": "¿Crear a partir de la versión actual?",
  "copyFromSelectedVersion": "Copiar de la versión seleccionada",
  "blankVersionNoLines": "Versión en blanco (sin partidas)",
  "label": "Etiqueta",
  "purpose": "Finalidad",
  "notes": "Notas",
  "optionalNotesForThisVersion": "Notas opcionales para esta versión",
  "createVersion": "Crear versión",
  "setAsCurrent": "Establecer como actual",
  "viewInBoardPortal": "Ver en el portal de la junta",
  "submitForBoardApproval": "Enviar para aprobación de la junta",
  "withdrawSubmission": "Retirar envío",
  "budgetSettings": "Configuración del presupuesto",
  "disableAutosave": "Desactivar guardado automático",
  "activateAutosave": "Activar guardado automático",
  "confirmStatusChange": "Confirmar cambio de estado",
  "confirm": "Confirmar",
  "department": "Departamento",
  "category": "Categoría",
  "searchGl": "Buscar cuenta contable",
  "searchByGlAccount": "Buscar por cuenta contable",
  "view": "Vista",
  "monthly": "Mensual",
  "quarterly": "Trimestral",
  "quarterlyViewEnabledForSmallerScreens": "Vista trimestral activada para pantallas pequeñas.",
  "addLine": "Añadir partida",
  "editBudgetLine": "Editar partida presupuestaria",
  "addBudgetLine": "Añadir partida presupuestaria",
  "glAccount": "Cuenta contable",
  "ownerOptional": "Responsable (opcional)",
  "searchStaffByNameOrEmail": "Buscar personal por nombre o correo",
  "unassigned": "Sin asignar",
  "noMatches": "Sin coincidencias",
  "typeAtLeast2CharactersToSearch": "Escriba al menos 2 caracteres para buscar.",
  "searchingStaff": "Buscando personal…",
  "selectAStaffMemberToAssignOwnership": "Seleccione una persona del equipo como responsable.",
  "uploadSupportingDocumentsForThisBudgetLine": "Cargue documentos justificativos para esta partida presupuestaria.",
  "deleteThisBudgetLine": "¿Eliminar esta partida presupuestaria?",
  "thisWillRemoveTheLineFromTheVersionYouCanReaddItLaterIfNeeded": "Se eliminará la partida de la versión. Podrá volver a añadirla más adelante si es necesario.",
  "versionDetails": "Datos de la versión",
  "created": "Creado",
  "saveDetails": "Guardar datos",
  "saving": "Guardando…",
  "thisVersionIsNotInDraftAndCannotBeEditedCreateANewVersionToContinueEditing": "Esta versión no está en borrador y no se puede editar. Cree una nueva versión para seguir editando.",
  "somethingWentWrong": "Se ha producido un error",
  "total": "Total",
  "noBudgetLinesYetUseAddLineToStartBuildingYourBudget": "Todavía no hay partidas. Pulse «Añadir partida» para empezar a elaborar el presupuesto.",
  "lineActions": "Acciones de la partida",
  "editLine": "Editar partida",
  "documents": "Documentos…",
  "deleteLine": "Eliminar partida",
  "supportingDocuments": "Documentos justificativos",
  "selectAGlAccountAndDepartmentToEnableDocumentUploads": "Seleccione una cuenta contable y un departamento para habilitar la carga de documentos.",
  "unableToLoadDocuments": "No se pueden cargar los documentos",
  "uploadFailed": "Error de carga",
  "deleteFailed": "Error al eliminar",
  "downloadFailed": "Error de descarga",
  "previewFailed": "Error de vista previa",
  "dragDropFilesHere": "Arrastre y suelte los archivos aquí",
  "pdfImagesWordDocsMax25mbEach": "PDF, imágenes, documentos de Word • máx. 25 MB por archivo",
  "hangTightWhileWePrepUploads": "Espere mientras se prepara la carga.",
  "browseFiles": "Seleccionar archivos",
  "loadingDocuments": "Cargando documentos…",
  "refresh": "Actualizar",
  "download": "Descargar",
  "uploading": "Cargando",
  "failed": "Error",
  "complete": "Completado",
  "noDocumentsAttachedYet": "Todavía no hay documentos adjuntos.",
  "documentPreview": "Vista previa del documento",
  "previewNotAvailableDownloadToViewThisFile": "Vista previa no disponible. Descargue el archivo para verlo.",
  "budgetLineDocuments": "Documentos de la partida presupuestaria",
  "attachSupportingDocumentsForThisBudgetLine": "Adjunte documentos justificativos para esta partida presupuestaria.",
  "openNamed": "Abrir {name}",
  "deleteNamed": "¿Eliminar «{name}»? Esta acción no se puede deshacer.",
  "valuesCurrency": "Todos los importes en {currency} ({symbol})",
  "updatedAt": "Actualizado: {date}",
  "createdAt": "Creado: {date}",
  "versionNumber": "Versión v{number}",
  "reforecastVersion": "Previsión revisada (v{number})",
  "statusSet": "Estado del presupuesto establecido en: {status}.",
  "ownerName": "Responsable: {name}",
  "departmentDefault": " (responsable predeterminado del departamento)",
  "autoSaveState": "Guardado automático: {state}",
  "on": "Activado",
  "off": "Desactivado",
  "submitting": "Enviando…",
  "withdrawing": "Retirando…",
  "searching": "Buscando…",
  "documentCountOne": "{count} documento",
  "documentCountMany": "{count} documentos",
  "uploadedAt": "Cargado: {date}",
  "noResults": "Ninguna partida coincide con los filtros.",
  "pending_open": "Enviado (pendiente de apertura por dirección general)",
  "votingOpen": "Votación abierta",
  "votingClosed": "Votación cerrada",
  "withdrawn": "Retirado",
  "close": "Cerrar",
  "errors": {
    "permissionDenied": "No tiene permiso para realizar esta acción. Contacte con la administración del club.",
    "invalidFields": "Compruebe el nombre, las fechas del ejercicio y el presupuesto o la versión seleccionados, y vuelva a intentarlo.",
    "budgetMissing": "Este presupuesto ya no está disponible. Vuelva a la lista de presupuestos.",
    "versionMissing": "Esta versión ya no está disponible. Actualice la página y seleccione otra versión.",
    "lineMissing": "Esta partida ya no está disponible. Actualice el presupuesto.",
    "versionReadOnly": "Esta versión es de solo lectura. Cree una nueva versión en borrador para realizar cambios.",
    "invalidTransition": "Este cambio de estado no está permitido. Actualice la página para comprobar el estado actual.",
    "deleteRestricted": "Solo se pueden eliminar presupuestos en borrador que no tengan versiones bloqueadas.",
    "duplicateLine": "Ya existe una partida con estos datos. Edite la partida existente.",
    "fileTooLarge": "Seleccione un archivo de un máximo de 25 MB.",
    "fileType": "Seleccione un PDF, una imagen o un documento de Word compatible.",
    "fileSizeMismatch": "El tamaño del archivo cargado no coincide. Vuelva a cargar el archivo.",
    "attachmentMissing": "Este documento ya no está disponible. Actualice la lista de documentos.",
    "withdrawRestricted": "Solo se puede retirar el envío antes de que se abra la votación.",
    "votesExist": "Ya hay votos registrados para esta moción.",
    "notSubmitted": "Esta versión del presupuesto no está enviada actualmente.",
    "motionMissing": "No se encontró ninguna moción pendiente para este envío."
  },
  "deleteBudgetConfirm": "¿Eliminar el presupuesto?"
};
